import axios from "axios";
import { showError, showSuccess } from "../utils/toast";

const axiosInstance = axios.create({
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add token
axiosInstance.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
    if (token && token !== "null" && token !== "undefined") {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor: 401 auto-logout + extract backend.message ONLY
axiosInstance.interceptors.response.use(
  (response) => {
    // 1. Show global success toast for mutations if a backend message exists
    if (response.config.method !== "get" && response.data?.message) {
      showSuccess(response.data.message);
    }
    return response;
  },
  (error) => {
    // 401 auto-logout (unchanged)
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("authUser");

      const publicRoutes = [
        "/login",
        "/customer-self-register",
        "/forgot-password",
        "/reset-password",
      ];
      if (!publicRoutes.includes(window.location.pathname)) {
        window.location.href = "/login";
      }
    }

    // Extract ONLY backend message and show global error toast
    if (error.response?.data?.message) {
      error.backendMessage = error.response.data.message;
      // Optionally prevent double error toasts if we wanted, but we will
      // rely on this global toast for all API errors.
      showError(error.backendMessage);
    } else {
      error.backendMessage = null; // Silent fail - no generic messages
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
